<template>
    <div>
        <b-card :style="{'max-width': '2000px', 'width': '1500px', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
            <b-card-text>
                <h4>Delivery List</h4>
            </b-card-text>

            <b-card-text>
                <div style="display: inline-block;">
                    <div>Truck:</div>
                    <b-form-select v-model="truck" :options="packet.trucks" v-on:change="get_truck_counts_by_date"></b-form-select>
                </div>

                <div style="display: inline-block;" v-if="truck_counts_by_date.length > 0">
                    <div>Delivery Date:</div>
                    <b-form-select v-model="delivery_date" :options="truck_counts_by_date" v-on:change="fetch_init"></b-form-select>
                </div>

                <!-- <b-button size="md" variant="success" style="display: inline-block;" @click="fetch_init">FETCH</b-button> -->
            </b-card-text>

            <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                <div v-if="items.length > 0" style="margin-top: 10px;">
                    <div style="background: crimson; color: white; font-size: 16px; padding: 5px; font-weight: bold;">DELIVERIES FOR {{delivery_date}} | {{ truck }}</div>
                    <table class="text-monospace" style="width: 100%; margin-top: 10px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <td class="ipt_tdhr">
                                    # 
                                </td>
                                <td class="ipt_tdhr" style="width: 150px;">
                                    INV ID
                                </td>
                                <td class="ipt_tdhr" style="width: 300px;">
                                    ITEMS
                                </td>
                                <td class="ipt_tdhr" style="width: 300px;">
                                    TRUCK PICKUP LOC
                                </td>
                                <td class="ipt_tdhr" style="width: 300px;">
                                    DESTINATION
                                </td>
                                <td class="ipt_tdhr" style="width: 300px;">
                                    ORDER TYPE
                                </td>
                                <td class="ipt_tdhr" style="width: 40px;" v-on:click="sortby('total_cubes')">
                                    TOTAL CUBES
                                </td>
                                <td class="ipt_tdhr" style="width: 40px;" v-on:click="sortby('zipcode')">
                                    ZIPCODE
                                </td>
                                <td class="ipt_tdhr">
                                    ACTION
                                </td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item,idx in items" v-bind:key="idx">
                                <td class="ipt_tdhr">
                                    {{ idx + 1 }}
                                </td>
                                <td class="ipt_tdhr" style="font-size: 12px;">
                                    {{ item.invoice_id }}
                                </td>
                                <!-- <td class="ipt_tdhr" style="font-size: 12px;">
                                    <div v-for="element, eidx in item.elements" v-bind:key="eidx" style="background: #f2f2f2; padding: 5px; margin-bottom: 3px; text-align: left; margin-top: 5px;">
                                        {{ packet.locsubsdict[element.locsub] }}
                                    </div>
                                </td> -->
                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    <div v-for="element, eidx in item.elements" v-bind:key="eidx" style="background: #f2f2f2; padding: 10px; margin-bottom: 3px; text-align: left; padding: 3px;">
                                        <div style="font-weight: bold;">
                                            {{ element.product_sku }} X {{ element.quantity }}

                                            <div style="font-size: 10px; font-weight: normal;">
                                                <b-form-radio 
                                                    v-model="element.delivered" 
                                                    value="true">
                                                    DELIVERED
                                                </b-form-radio>
                                                <b-form-radio v-model="element.delivered" 
                                                value="false">
                                                    NOT DELIVERED
                                                </b-form-radio>
                                            </div>

                                        </div>
                                    </div>
                                </td>

                                <td class="ipt_tdhr" style="font-weight: normal;">
                                    <div v-for="element, eidx in item.elements" v-bind:key="eidx" style="background: #f2f2f2; padding: 10px; margin-bottom: 3px; text-align: left; padding: 3px;">
                                        <div style="font-weight: bold;">
                                            {{ packet.locationsdict[element.truck_pick_location].toUpperCase() }}
                                        </div>
                                        <!-- <div style="font-size: 10px;">
                                            STATE: {{ element.state }}
                                        </div> -->
                                         
                                    </div>
                                </td>
                                
                                <td class="ipt_tdhr" style="font-size: 11px;">
                                    <div v-if="item.order_type == 'home_delivery'">
                                        <div>{{item.customer.fullname}}</div>
                                        <div style="font-weight: normal;">{{item.customer.address_line_1}}</div>
                                        <div style="font-weight: normal;">{{item.customer.address_line_2}}</div>
                                        <div style="font-weight: normal;">{{item.customer.city}}, {{item.customer.state}}</div>
                                    </div>
                                    <div v-else-if="item.order_type == 'store_pickup'">
                                        {{ packet.locationsdict[item.location_id] }}
                                    </div>
                                </td>
                                <td class="ipt_tdhr">
                                    {{ order_types_dict[item.order_type] }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.total_cubes }}
                                </td>
                                <td class="ipt_tdhr">
                                    {{ item.zipcode }}
                                </td>
                                <td class="ipt_tdhr">
                                    <b-button size="sm" variant="primary" @click="update_delivery_items(item)" >UPDATE</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>  
                        
                </div>
                <div v-else>
                    <b-alert show variant="warning">No records</b-alert>
                </div>
            </b-overlay>
        </b-card>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"

    export default {
        name: "DeliveriesListDeliveries",
        components: {Backer, flatPickr},
        data: function() {
            return {
                packet: {},
                items: [],
                items_being_loaded: false,
                global_vars: global_vars,
                delivery_date: null,
                truck: null,
                picked_date_range: null,
                items_state_dict: {
                    "rts": "READY TO SHIP",
                    "raw": "RCVD AT WRHS",
                    "picked": "PICKED",
                    "atdl": "ADDED",
                    "delivered": "DELIVERED"
                },
                truck_counts_by_date: [],
                order_types_dict: {
                    "home_delivery": "HOME DELIVERY",
                    "store_pickup": "STORE PICKUP",
                },
                sort_asc: true,
            }
        },
        methods: {
            
            fetch_init: function(e) {
                //let dates = this.date_range.split(" to ");
                // let location_id = this.packet.userDetails.properties.location_id;
                // if (this.packet.userDetails.userrole == 'admin'){
                //     location_id = null
                // }
                let that = this;
                let data = {truck: this.truck, delivery_date: this.delivery_date}
                let path = "/api/transfers/get_delivery_items_for_truck/"
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items = []
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            mark_as_delivered: function(item){
                let that = this;
                let data = {invoice_id: item.invoice_id, product_sku: item.item.product_sku}
                let path = "/api/transfers/set_item_state_to_delivered/"
                let s = function(response) {
                    if (response.data.result){
                        item.item.state = "atdl";
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            mark_cannot_be_delivered: function(item){
                let that = this;
                let data = {invoice_id: item.invoice_id, product_sku: item.item.product_sku}
                let path = "/api/transfers/mark_cannot_be_delivered/"
                let s = function(response) {
                    if (response.data.result){
                        item.item.state = "atdl";
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            get_truck_counts_by_date: function(truck){
                let that = this;
                let data = {truck: truck}
                let path = "/api/transfers/get_truck_counts_by_date/"
                let s = function(response) {
                    if (response.data.result){
                        that.truck_counts_by_date = response.data.result
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false
                }
                this.truck_counts_by_date = []
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            //this.fetch_init()
        }
    }
</script>

<style scoped>
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/Deliveries/DeliveriesListDeliveries.vue